import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MessageService, SelectItem, DialogService } from 'primeng/api';
import { TagManagerService } from 'src/app/service/tagmanager/tagmanager.service';
import { FormularioCliente } from '../../models/formcliente.component';
import { ClienteService } from '../../service/cliente/cliente.service';

import {
  MSJ_ERROR_CUERPO, MSJ_ERROR_TIULO, MSJ_EXITO_SUBTIULO, MSJ_EXITO_TIULO,
  MSJ_EXITO_CUERPO, MSJ_ERROR_SUBTIULO
} from '../../util/Constantes'
import { ModalComponent } from './modal/modal.component';
declare var $: any;

@Component({
  selector: 'app-sorteo-milsoles',
  templateUrl: './sorteo-milsoles.component.html',
  styleUrls: ['./sorteo-milsoles.component.css'],
  providers: [DialogService, MessageService]
})
export class SorteoMilsolesComponent implements OnInit {

  public formularioCliente: FormularioCliente;

  public sexos;
  public chk_terminos: any;
  public display: boolean = false;
  closeResult: string;
  public maxLengthDoc: any = 8;
  es: any;
  public comp1Validacion: boolean = false;
  public comp2Validacion: boolean = false;
  public txtComp1Validacion: any = "Validacion";
  public txtComp2Validacion: any = "Validacion 2";
  public styleExpComprobante: any = { 'display': 'none' };

  public maxDate: Date;
  public dates: Date[];
  public rangeDates: Date[];
  public minDate: Date;
  invalidDates: Array<Date>
  public date2: Date;

  public tipsex: SelectItem[];
  public tipdoc: SelectItem[];
  public documentoTerminosYCondiciones: string;

  correValido: boolean = false;
  public ronly: boolean;
  public regex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
  public regex1 = /^[a-z][\w.-]+@\w[\w.-]+\.[\w.-]*[a-z][a-z]$/i;
  public mensajeResultadoTitulo = '';
  public mensajeResultadoSubtitulo = '';
  public mensajeResultadoCuerpo = '';
  public estadoRegistro: boolean;

  serieFormulario: string;
  numeroFormulario: string;
  selectTipoDocumento: any;
  selectSexo: any;
  tamanioDocumento: number;

  form: FormGroup;
  hidden = false;
  maxLength = 8;

  /* Campos para buscar los ganadores */
  datosGanadores: any[];
  dataGanadoresFiltrado: any[];
  tarjetaGanador: boolean = false;
  mensajeGano: boolean = false;
  mensajeNoGano: boolean = false;
  dataFecha: string;
  iconoLoad: boolean = false;

  constructor(
    private _clienteService: ClienteService,
    public _service: MessageService,
    private tagManagerService: TagManagerService,
    public _dialogService: DialogService
  ) { }

  ngOnInit() {
    this.removeBackgroundImage();
    this.ronly = true;

    this.form = new FormGroup({
      'serieBoleta': new FormControl('', Validators.required),
      'numeroBoleta': new FormControl('', Validators.required),
      'tipoDocEntidad': new FormControl('', Validators.required),
      'nombres': new FormControl(null, Validators.required),
      'appaterno': new FormControl(null, Validators.required),
      'apmaterno': new FormControl(null, Validators.required),
      'correo': new FormControl(null, [Validators.required, Validators.email]),
      'dni': new FormControl('', Validators.required),
      'celular': new FormControl(null, [Validators.required, Validators.minLength(9), Validators.maxLength(9)]),
      'checkRecibir': new FormControl(false, Validators.required),
      'checkInkaclub': new FormControl(false)
    }, { validators: this.tipoDocumentoValid('tipoDocEntidad', 'dni') });

    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dec"],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'dd/mm/yy'
    };

    this.tipsex = [];
    this.tipsex.push({ label: 'Sexo', value: 'Sexo' });
    this.tipsex.push({ label: 'Masculino', value: 'Masculino' });
    this.tipsex.push({ label: 'Femenino', value: 'Femenino' });

    this.tipdoc = [];
    this.tipdoc.push({ label: 'Tipo de documento', value: 'Tipo' });
    this.tipdoc.push({ label: 'DNI', value: '01' });
    this.tipdoc.push({ label: 'Carnet de extranjería', value: '02' });

    this.selectTipoDocumento = "Tipo de Documento";
    this.selectSexo = "Sexo";


  }


  get f() { return this.form.controls; }

  tipoDocumentoValid(control1: string, control2: string) {
    return (group: FormGroup) => {
      const tipoDocumento = group.controls[control1].value;
      const documento = group.controls[control2].value;

      if (tipoDocumento === '01' && documento.length == 8) {
        return null;
      } else if (tipoDocumento === '02' && documento.length == 10) {
        return null;
      } else {
        return {
          tipoDocumentoValid: true
        }
      }

    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  OnRegistrar() {

    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => control.markAsTouched());
    }
    this.tagManagerService.sendEvent('registerInkaClub');

    this.formularioCliente = new FormularioCliente(null, null, null,
      'Sexo', null, null, null, null, null, null, null, true, null, null, null, null, null, true, null, null, null);

    this.formularioCliente.id_proveedor = 169;
    this.formularioCliente.id_empresa = 1;
    this.formularioCliente.codDepartamento = '014';
    this.formularioCliente.codProvincia = '001';
    this.formularioCliente.codDistrito = '010';
    this.formularioCliente.apeMaterno = this.form.value['apmaterno'];
    this.formularioCliente.apePaterno = this.form.value['appaterno'];
    this.formularioCliente.nombres = this.form.value['nombres'];
    this.formularioCliente.comprobante = this.form.value['serieBoleta'] + '-' + this.form.value['numeroBoleta'];
    this.formularioCliente.fechaNacimiento = new Date().toString();
    this.formularioCliente.tipoDocEntidad = this.form.value['tipoDocEntidad'];
    this.formularioCliente.dni = this.form.value['dni'];
    this.formularioCliente.correo = this.form.value['correo'];
    this.formularioCliente.celular = this.form.value['celular'];
    this.formularioCliente.check_inkaclub = this.form.value['checkInkaclub'];
    this.formularioCliente.check_recibir = this.form.value['checkRecibir'];

    console.log(this.formularioCliente);

    this._clienteService.guardarCliente(this.formularioCliente).subscribe(data => {
      this.estadoRegistro = true;
      this.mensajeResultadoTitulo = MSJ_EXITO_TIULO;
      this.mensajeResultadoSubtitulo = MSJ_EXITO_SUBTIULO;
      this.mensajeResultadoCuerpo = MSJ_EXITO_CUERPO;

      sessionStorage.setItem("status", "success");
      this.hidden = true;
      this.formularioCliente = new FormularioCliente(null, null, null,
        'Sexo', null, null, null, null, null, null, null, true, null, null, null, null, null, true, null, null, null);
    }, (error) => {
      this.estadoRegistro = false;
      this.hidden = true;
      this.mensajeResultadoTitulo = MSJ_ERROR_TIULO;
      this.mensajeResultadoSubtitulo = MSJ_ERROR_SUBTIULO;
      this.mensajeResultadoCuerpo = MSJ_ERROR_CUERPO;
    });

  }

  onTipoDocumentoChange() {
    const tipoDocumento = this.form.controls['tipoDocEntidad'].value;
    if (tipoDocumento === '02') {
      this.maxLength = 10;
    }
  }

  getDocument() {
    const request = { accountNumber: this.form.value['dni'] };
    this._clienteService.buscaAfiliadoInkaFarma(request).subscribe(
      (data: any) => {
        if (data.accountNumber.length > 0) {
          this.form.patchValue({
            nombres: data.name,
            appaterno: data.lastNamePaternal,
            apmaterno: data.lastNameMaternal
          });
        }
      },
    );
  }

  removeBackgroundImage() {
    const body = document.querySelector('body.light-page');
    body.classList.remove('bg-top');
    // body.classList.add('bgtena');
  }

  mostrarDialogo() {
    this._dialogService.open(ModalComponent, {
      closable: false,
      closeOnEscape: true,
      dismissableMask: true,
    });
  }


  findWinner(event: any) {
    console.log(event.target.value);
    if (event.target.value != '') {
      setTimeout(() => {
        this.iconoLoad = !this.iconoLoad;
        this._clienteService.obtenerGanadores().subscribe(data => {
          this.datosGanadores = data;
        }
        ).add(() => {
          this.filtroDni(event.target.value);
        });
      }, 500);
      this.iconoLoad = !this.iconoLoad;
    }
    else {
      this.mensajeNoGano = false;
    }
  }

  filtroDni(value: any) {
    if (this.datosGanadores.filter(x => x.dni == value).length != 0) {
      let dato: any[] = this.datosGanadores.filter(x => x.dni == value);
      this.filtroFecha(dato[0].fecha);
    } else {
      this.tarjetaGanador = false;
      this.mensajeGano = false;
      this.mensajeNoGano = true;
    }
  }

  filtroFecha(fechaParam: string) {
    this.dataGanadoresFiltrado = this.datosGanadores.filter(x => x.fecha == fechaParam);
    this.tarjetaGanador = true;
    this.mensajeGano = true;
    this.mensajeNoGano = false;
    this.dataFecha = this.dataGanadoresFiltrado[0].fecha;
  }

  mostrarIcono() {
  }

}
